import { useCallback } from 'react';

import { useSearchParams } from 'react-router-dom';

import { SearchInput } from '@modules/_shared/components/search-input/SearchInput';
import { useLocale } from '@shared/hooks/locale';

const SEARCH_PARAM = 'search';

export const LeadListSearch = () => {
  const { t } = useLocale();
  const [searchParams, setSearchParams] = useSearchParams();

  const applySearchParam = useCallback(
    (nextValue: string) => {
      const nextSearchParams = new URLSearchParams(searchParams);
      const trimmedValue = nextValue.trim();

      if (trimmedValue) {
        nextSearchParams.set(SEARCH_PARAM, trimmedValue);
      } else {
        nextSearchParams.delete(SEARCH_PARAM);
      }

      nextSearchParams.delete('offset');
      setSearchParams(nextSearchParams);
    },
    [searchParams, setSearchParams],
  );

  return (
    <SearchInput
      value={searchParams.get(SEARCH_PARAM) ?? ''}
      placeholder={t('Search leads')}
      sx={{ maxWidth: 350, minWidth: 100, flexGrow: 1, ml: 1 }}
      onValueChanged={applySearchParam}
    />
  );
};
